module.exports = __webpack_public_path__ + "img/conny-f-stage6-hungry.a2994b79.png";